module.exports = __webpack_public_path__ + "img/trackunit-logo-white.c3481c11.svg";